import { RootRoute } from './RootRoute';

type RootRouteData = {
  /** Pathname prefix @see RootRoute serves its React Router pages from. */
  basePath: string;
};

export const rootRouteData: Partial<Record<RootRoute, RootRouteData>> = {
  [RootRoute.intents]: {
    basePath: '/app/intent'
  },
  [RootRoute.settings]: {
    basePath: '/app/settings'
  }
} satisfies Record<RootRoute.intents | RootRoute.settings, RootRouteData>;
